import React from "react";

const SassTips = () => {
  return (
    <div className="blog-content-in">
      <h3 className="heading">SASS Tips & Tricks: Functions, Mixins and Maps</h3>

      <div className="subheading-content">
        <h4 className="subheading">Introduction:</h4>
        <p className="blog-text">
          Sass is a powerful CSS preprocessor that enhances your styling workflow
          by providing advanced features such as variables, nesting, mixins,
          functions, and maps. These features make your styles more flexible,
          maintainable, and scalable. In this article, we explore essential Sass
          techniques every frontend developer should know.
        </p>
      </div>

      <div className="subheading-content">
        <h4 className="subheading">1. Using Functions for Reusable Logic:</h4>
        <p className="blog-text">
          Sass functions allow you to create reusable logic that returns values
          such as colors, calculations, spacing, or combining units.
          <br /><br />
          For example, a function that lightens or darkens colors ensures
          consistent styling across your system:
          <br /><br />
          <code>@function spacing($multiplier) &#123; @return $multiplier * 8px; &#125;</code>
          <br /><br />
          With this approach, spacing becomes standardized and easy to maintain.
        </p>
      </div>

      <div className="subheading-content">
        <h4 className="subheading">2. Creating Mixins for Reusable Styles:</h4>
        <p className="blog-text">
          Mixins are one of the most powerful features in Sass. They allow you to
          group CSS declarations and reuse them throughout your project.
          <br /><br />
          Common use cases include:
          <br />• Responsive breakpoints  
          <br />• Flexbox helpers  
          <br />• Animations  
          <br />• Shadows and gradients  
          <br /><br />
          Example:
          <br /><br />
          <code>@mixin flex-center &#123; display: flex; justify-content: center; align-items: center; &#125;</code>
          <br /><br />
          Mixins reduce repetition and make your components more consistent.
        </p>
      </div>

      <div className="subheading-content">
        <h4 className="subheading">3. Working with Maps for Organized Styling:</h4>
        <p className="blog-text">
          Sass maps allow you to store related values in a single structure and
          access them dynamically. This is extremely useful for color palettes,
          typography scales, spacing systems, and themes.
          <br /><br />
          Example of a color map:
          <br /><br />
          <code>
            $colors: (  
            &nbsp;&nbsp;primary: #4f7df3,  
            &nbsp;&nbsp;secondary: #222,  
            &nbsp;&nbsp;light: #f4f4f4  
            );
          </code>
          <br /><br />
          You can access values with:
          <br />
          <code>color: map-get($colors, primary);</code>
          <br /><br />
          Maps help centralize style systems and avoid scattered values across files.
        </p>
      </div>

      <div className="subheading-content">
        <h4 className="subheading">4. Combining Functions, Mixins, and Maps:</h4>
        <p className="blog-text">
          Combining these Sass features enhances the scalability of your styling
          architecture. Use functions to calculate values, maps to store design
          tokens, and mixins to apply reusable patterns.
          <br /><br />
          This creates a flexible, design-system-based workflow across your
          application.
        </p>
      </div>

      <div className="subheading-content">
        <h4 className="subheading">5. Keeping Sass Clean and Organized:</h4>
        <p className="blog-text">
          While Sass is powerful, it can also become messy if not organized well.
          Follow these guidelines:
          <br /><br />
          • Keep functions small and single-purpose  
          • Use naming conventions (like BEM) along with Sass  
          • Avoid deep nesting (max 3 levels)  
          • Organize your project with folder structures like the 7-1 architecture  
          <br /><br />
          A clean Sass environment boosts productivity and reduces long-term
          maintenance headaches.
        </p>
      </div>      
    </div>
  );
};

export default SassTips;
